import { render, staticRenderFns } from "./media-carousel.vue?vue&type=template&id=5375f440&"
import script from "./media-carousel.vue?vue&type=script&lang=js&"
export * from "./media-carousel.vue?vue&type=script&lang=js&"
import style0 from "./media-carousel.vue?vue&type=style&index=0&id=5375f440&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports